import React from 'react';
import {ChipField, ReferenceField, TabbedShowLayout, TextField} from 'react-admin';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import {propertyRowStyle} from "../../tools_property_row_style";
import {d4UrlSchema} from "../../Env";
import {renderDateField, renderIfExists, renderProperties, renderReferenceField} from '../../d4tools_tab';

function D4LocTabLocation(props, controllerProps) {
    const {record} = controllerProps;

    // Check if the component should be rendered
    const shouldRender = record &&
        record['@context'] &&
        JSON.stringify(Object.values(record['@context'])).includes(`${d4UrlSchema}/location.jsonld`);

    if (!shouldRender) return null;

    return (
        <TabbedShowLayout.Tab label="Location" icon={<LocationCityIcon/>}>
            <TextField label="Name" source="location:objName"/>
            {renderIfExists(record, "location:description",
                <TextField label="Description" source="location:description"/>
            )}
            {renderReferenceField(record, "location:hasPart", "locations", "Has Part", props)}
            {renderIfExists(record, "location:isPartOf",
                <ReferenceField label="Is Part Of" source="location:isPartOf" reference="locations">
                    <ChipField source="objName" clickable/>
                </ReferenceField>
            )}
            {renderIfExists(record, "location:containedIn",
                <ReferenceField label="Contained In" source="location:containedIn" reference="locations">
                    <ChipField source="objName" clickable/>
                </ReferenceField>
            )}
            {renderReferenceField(record, "location:containsProduct", "products", "Contains Product", props)}
            {renderIfExists(record, "location:tags", <TextField source="location:tags"/>)}
            {renderReferenceField(record, "location:tags", "tags", "Tags", props)}
            {renderProperties(record, "location:properties", propertyRowStyle)}
            {renderDateField(record, "location:created", "Created")}
            {renderDateField(record, "location:expired", "Expired")}
        </TabbedShowLayout.Tab>
    );
}

export default D4LocTabLocation;
